import { z } from "zod";

export const chapterActivityFormSchema = z.object({
  chapterActivityName: z.string().min(1, "Activity name is required"),
  chapterActivityDate: z.string().min(1, "Activity date is required"),
  activityType: z.string().min(1, "Activity type is required"),
  ofNscsMembers: z.preprocess(
    (val) => parseInt(String(val), 10),
    z.number().min(0, "Number must be 0 or greater"),
  ),
  ofNonNscsMembers: z.preprocess(
    (val) => parseInt(String(val), 10),
    z.number().min(0, "Number must be 0 or greater"),
  ),
  advisorPresent: z.boolean(),
  description: z.string().min(10, "Description must be at least 10 characters"),
  otherCampusOrgsInvolved: z.string().optional(),
});

export type ChapterActivityFormData = z.infer<typeof chapterActivityFormSchema>;
